'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VSheet = undefined;

var _VSheet = require('./VSheet');

var _VSheet2 = _interopRequireDefault(_VSheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.VSheet = _VSheet2.default;
exports.default = _VSheet2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VSheet/index.js
// module id = 525
// module chunks = 0